/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LiveManagementCreateLivecarpItemRequest = {
    id?: number;
    livecarpId?: number;
    code: string;
    isNarita?: boolean;
    producer: string;
    producerEn?: string;
    producerCn?: string;
    kind?: string;
    kindEn?: string;
    kindCn?: string;
    ageId?: number;
    sex?: LiveManagementCreateLivecarpItemRequest.sex;
    size?: number;
    endTime: string;
    parent?: string;
    parentEn?: string;
    parentCn?: string;
    startPrice: number;
    note?: string;
    noteEn?: string;
    noteCn?: string;
    status: LiveManagementCreateLivecarpItemRequest.status;
};

export namespace LiveManagementCreateLivecarpItemRequest {

    export enum sex {
        MALE = 'male',
        FEMALE = 'female',
        UNKNOWN = 'unknown',
    }

    export enum status {
        RELEASE = 'release',
        CANCEL = 'cancel',
    }


}

